import { chunkArray, priceNotation } from '../../../utils/safe'
import Trans from '../../atoms/Trans/Trans'

const DettagliProdottoListino = ({ prezzi }) => {

  return (
    <div className="dettagli-prodotto__listino">
      {Object.entries(prezzi).map((item, i) => (
        <div className="dettagli-prodotto__listino__block" key={i}>
          <p className="dettagli-prodotto__listino__block-title">{item[1][0].nome}</p>
          {chunkArray(item[1], 6).map((
            chunk,
            i // divido i prezzi in gruppi di massimo 6 elementi e li dispongo su più righe
          ) => (
            <div className="dettagli-prodotto__listino__table" key={`chunk-${i}`}>
              <div className="dettagli-prodotto__listino__col">
                <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                  <Trans chiave="A partire da" />
                </p>
                <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                  <Trans chiave="Prezzo personalizz." />
                </p>
              </div>

              {chunk.map((obj, j) => {
                return (
                  <div key={j} className="dettagli-prodotto__listino__col">
                    <div className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity">
                      {obj.a_partire_da}
                    </div>
                    <div className="dettagli-prodotto__listino__cell">
                      {priceNotation(obj.prezzo_personalizzazione, 3)} €
                    </div>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default DettagliProdottoListino
